// Copyright (c) 2025. CYBERKOALA LLC.
//
// SPDX-License-Identifier: Proprietary License.
//
// Redistribution and use in source and binary forms, with or without
// modification, are restricted.

import { createContext } from 'react';
import { emptyFn } from '@/lib/utils';
import { UserPlan } from '@/models';

interface SessionUser {
  id: string;
  email: string;
  name: string | null;
  nickname: string | null;
  image: string | null;
  phone: string | null;
  plan: UserPlan; // Used with device check delete
  isTwoFactorEnabled: boolean;
  emailVerified: Date | null;
}

interface AuthContextProps {
  user: SessionUser | null;
  setUser: (user: SessionUser | null) => void;
  logout: () => Promise<void>;
  checkSession: (force?: boolean) => Promise<void>;
  isLoading: boolean;
  userUpdatedAt: number;
  deleteCookiesAndSession: () => Promise<void>;
}

export const AuthContext = createContext<AuthContextProps>({
  user: null,
  setUser: emptyFn,
  logout: emptyFn,
  checkSession: emptyFn,
  isLoading: true,
  userUpdatedAt: 0,
  deleteCookiesAndSession: emptyFn,
});
